import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/order-list-and-tracking')({
  staticData: {
    breadcrumb: 'Order List & Tracking',
  },
})
